module.exports = __webpack_public_path__ + "static/media/SAPInnovativeTeachingLearningActivityReport.ec18ff55.pdf";